import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../../../shared/shared.module';
import { InvoiceListComponent } from './invoice-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    SharedModule,
    NgbModule,
    DataTableModule
  ],
  declarations: [InvoiceListComponent],
  exports: [InvoiceListComponent]
})
export class InvoiceListModule { }
